import React, { useState } from 'react';
import SearchIcon from './../images/search.svg'

const SearchBar = ({ toggleMenu, add_class }) => {
  const [value, setValue] = useState('');

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (value.trim()) {
  //     const formattedQuery = value.trim().replace(/\s+/g, '-'); // Replace spaces with hyphens
  //     navigate(`/search?query=${formattedQuery}`);
  //     toggleMenu(); // Toggle the menu after navigating
  //   }
  // };
  
  const handleSubmit = () => {}

  return (
    <form onSubmit={handleSubmit} method="get" className={`${add_class}`}>
      <div className="dark:bg-black_secondary bg-[#b2d8b1] w-full h-14 rounded-md dark:text-[#A1A1AA] p-6 outline-none text-[20px] flex items-center justify-between">
        <input
          className="bg-transparent w-full outline-none pr-6"
          placeholder="Search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button type="submit">
          {/* Ensure this image path works with Gatsby */}
          <img src={SearchIcon} loading="lazy" alt="Search" className="h-6 w-6" />
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
